import { gql } from '@apollo/client';

export const UPDATE_CAMPAIGN_MESSAGE = gql`
  mutation UpdateCampaignMessage($id: ID!, $message: String!) {
    updateCampaignMessage(input: { id: $id, message: $message }) {
      campaignMessage {
        id
        message
        status
        updatedAt
      }
      errors
    }
  }
`;

export const REGENERATE_CAMPAIGN_MESSAGE = gql`
  mutation RegenerateCampaignMessage($id: ID!) {
    regenerateCampaignMessage(input: { id: $id }) {
      campaignMessage {
        id
        message
        status
        updatedAt
      }
      errors
    }
  }
`; 